import { ICoreApp } from '../../typed/core-app';
import { ICheckBoxListUser } from '../../typed/user';
import { ISelectOption } from '../../typed/wild';


export interface VWorkManage {
  workmanage: IWorkManage;
  Users: ICheckBoxListUser[];
  coreApps: ICoreApp[];
  workmanageList: IWorkManage[];
}

export interface IWorkManage {
  workmanageID: number;
  name: string;
  checked: boolean;
}

export class CWorkManage {
  public workmanageID = 0;
  public name = '';
  public checked = false;
}

export interface IWorkManageModerator {
  workmanageID: number;
  userId: number;
}

export interface VEditWorkManageInfo {
  workmanage: IWorkManage;
  userIDs: number[];
  coreApps: ICoreApp[];
}

export interface IWorkManageUsedUser extends ICheckBoxListUser {
  workmanageID: number;
  selectUserId: number;
}

export interface VWorkManageUsers {
  users: IWorkManageUsedUser[];
  departments: ISelectOption[];
}
